module.exports = __webpack_public_path__ + "static/lab-girl-e9a3b2909b09cd0b556a3a530a97410a.jpg";